// extracted by mini-css-extract-plugin
export default {"content":"content_L1uV"};